module.exports = __webpack_public_path__ + "img/logo-19.c8042018.png";